import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface RewardPointRequest extends APIRequest
{
    getMsisdn(): string;
    getToken(): string;
}

export class RewardPointRequestImpl extends APIRequestDtoImpl implements RewardPointRequest
{
    constructor(private msisdn: string, private token: string)
    {
        super();
    }

    getMsisdn(): string
    {
        return this.msisdn;
    }

    getToken(): string
    {
        return this.token;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/rewardpoint/rewardpointrequest.tsx